// React
import React from 'react';
import PropTypes from 'prop-types';

import style from '../ResultsVisualization.scss';

const ChoiceLabel = (props) => {
	const {
		title,
		theming,
	} = props;

	const choiceLabelTheming = theming['styles.interactions.polls.studio.results.choice_label'] || {};
	return (
		<div className={style.results__choiceresult__wrapper}>
			<div className={style.results__choiceresult__labelwrapper}>
				<span className={style.results__choiceresult__label} style={choiceLabelTheming}>{title}</span>
			</div>
		</div>
	);
};

ChoiceLabel.propTypes = {
	title: PropTypes.string.isRequired,
	theming: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

export default ChoiceLabel;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/resultsvisualization/childcomponents/choicelabel.js